import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import authService from '../api/authService';
import Toast from '../components/Toast';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [maskedEmail, setMaskedEmail] = useState('');
  const [apiMessage, setApiMessage] = useState('');
  const [toast, setToast] = useState({ message: '', type: 'danger' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim()) return;
    setLoading(true);
    setToast({ message: '', type: 'danger' });
    try {
      const res = await authService.forgotPassword(username.trim());
      setMaskedEmail(res?.data?.data?.email || '');
      setApiMessage(res?.data?.message || '');
      setSubmitted(true);
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        'Une erreur est survenue. Veuillez réessayer.';
      setToast({ message, type: 'danger' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#faf9f7', display: 'flex', flexDirection: 'column' }}>
      <Toast message={toast.message} type={toast.type} onClose={() => setToast({ message: '', type: 'danger' })} />
      <div style={{ backgroundColor: '#8b1512', padding: '16px 0', textAlign: 'center' }}>
        <h4 className="text-white m-0" style={{ letterSpacing: '2px', fontFamily: 'serif' }}>
          MINISTÈRE CATHOLIQUE MISERICORDE
        </h4>
      </div>

      <Container className="d-flex flex-column align-items-center justify-content-center" style={{ flex: 1, paddingTop: '2rem', paddingBottom: '2rem' }}>
        <img src="/logo192.png" alt="MCM Logo" style={{ width: '140px', height: '174px', marginBottom: 24 }} />

        <Card style={{ width: '100%', maxWidth: 500, border: 'none', borderRadius: 12 }} className="shadow-sm p-4">
          <h5 className="text-center fw-bold mb-4">Réinitialiser le mot de passe</h5>

          {submitted ? (
            <>
              <Alert variant="success" className="py-3 mb-3">
                {apiMessage || <strong>E-mail envoyé.</strong>}
                {maskedEmail && (
                  <div style={{ marginTop: 8, fontSize: 13 }}>
                    Vérifiez la boîte : <strong>{maskedEmail}</strong>
                  </div>
                )}
                <div style={{ fontSize: 13, color: '#555', marginTop: 6 }}>
                  Le lien expire dans <strong>15 minutes</strong>. Vérifiez aussi vos spams.
                </div>
              </Alert>
            </>
          ) : (
            <>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold" style={{ fontSize: 14 }}>Nom d'utilisateur</Form.Label>
                  <Form.Control
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Votre nom d'utilisateur"
                  />
                </Form.Group>
                <Button type="submit" disabled={loading} className="w-100 fw-bold"
                  style={{ backgroundColor: '#8b1512', border: 'none', height: 48, letterSpacing: 1 }}>
                  {loading ? <Spinner size="sm" animation="border" /> : 'Envoyer le lien'}
                </Button>
              </Form>
            </>
          )}

          <p className="text-center mt-3 mb-0 text-secondary fw-semibold"
            style={{ cursor: 'pointer', fontSize: '16px' }}
            onClick={() => navigate('/login')}>
            ← Retour à la connexion
          </p>
        </Card>
      </Container>
    </div>
  );
}
